import HttpUtil from "../HttpUtil"
import { ProjectResInfo } from "../Model/ResponseModel";
import Urls from "../Urls"

const  GetUserInfo=():Promise<ProjectResInfo>=>{
    return  HttpUtil.XCHttpPost<any,ProjectResInfo>(Urls.UserInfo,"",true,false);
}
export default{
    GetUserInfo:GetUserInfo
}